import { Button, Modal } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '@src/store'
import { updateTemplate } from '@src/services/config.service'
import { notificationAlert } from '@src/modules/atoms/notification'

interface ISaveOrDiscardChangeModal {
  changeLang: () => void
  onClose: () => void
}

const SaveOrDiscardChangeModal: React.FC<ISaveOrDiscardChangeModal> = ({ changeLang, onClose }) => {
  const baseProps = useSelector(({ baseProps }: RootState) => baseProps)
  const { currentTemplate } = useSelector(({ configuration }: RootState) => configuration)

  const fetchUpdateTemplate = () => {
    const { title, content, workspace, sign_order, tags } = currentTemplate

    updateTemplate(
      baseProps,
      currentTemplate.token!,
      { title, content, workspace: workspace?.token!, sign_order, tags },
      currentTemplate.lang
    ).then(({ success }) => {
      if (success) {
        notificationAlert({
          message: 'Plantilla actualizada',
          description: 'La plantilla se ha modificado correctamente',
          variant: 'success'
        })
        changeLang()
        onClose()
      }
    })
  }

  const onSaveChange = () => {
    fetchUpdateTemplate()
    changeLang()
    onClose()
  }

  const onDiscardChange = () => {
    changeLang()
    onClose()
  }

  return (
    <Modal
      visible
      title='¿Guardar cambios?'
      onCancel={onClose}
      footer={[
        <Button key='discard' onClick={onDiscardChange}>
          Descartar cambios
        </Button>,
        <Button key='save' type='primary' onClick={onSaveChange}>
          Guardar
        </Button>
      ]}
    >
      <p>Tienes cambios sin guardar. ¿Prefieres guardarlos antes de salir de esta página?</p>
    </Modal>
  )
}

export default SaveOrDiscardChangeModal
